const el=id=>document.getElementById(id);
const form=el('event-form');let previewed=false;
function selectedInterests(){return [...form.querySelectorAll('input[name="interest"]:checked')].map(x=>x.value);}
function sync(){const coffee=selectedInterests().includes('Coffee & tea');el('coffee-options').hidden=!coffee;if(previewed){el('event-status').textContent='Details changed. Preview again to refresh your brief.';}}
function row(label,value){if(!value.trim())return;if(label==='Preferred time'){const [h,m]=value.split(':').map(Number);value=`${h%12||12}:${String(m).padStart(2,'0')} ${h>=12?'PM':'AM'}`;}if(label==='Preferred date'){const [y,m,d]=value.split('-').map(Number);value=new Date(y,m-1,d).toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'});}const item=document.createElement('div');item.className='summary-row';for(const text of [label,value]){const span=document.createElement('span');span.textContent=text;item.append(span);}el('event-brief').append(item);}
form.addEventListener('input',sync);form.addEventListener('change',sync);
for(const link of document.querySelectorAll('[data-interest]'))link.addEventListener('click',()=>{const field=form.querySelector('input[data-key="'+link.dataset.interest+'"]');if(field)field.checked=true;sync();});
window.cateringRequestValidate = () => (sync(), true);
sync();

// Keep carousel controls in sync with both manual scrolling and button navigation.
const dishTrack=el('dish-track');
const dishSlides=[...dishTrack.querySelectorAll('.dish-slide')];
let dishIndex=0;
function showDish(index){
  dishIndex=Math.max(0,Math.min(dishSlides.length-1,index));
  dishTrack.scrollTo({left:dishSlides[dishIndex].offsetLeft-dishSlides[0].offsetLeft,behavior:'instant'});
  syncDish();
}
function syncDish(){
  const origin=dishSlides[0].offsetLeft;
  dishIndex=dishSlides.reduce((best,slide,index)=>Math.abs(slide.offsetLeft-origin-dishTrack.scrollLeft)<Math.abs(dishSlides[best].offsetLeft-origin-dishTrack.scrollLeft)?index:best,0);
  el('dish-choice').value=String(dishIndex);
  el('dish-position').textContent=(dishIndex+1)+' / '+dishSlides.length;
  el('dish-prev').disabled=dishIndex===0;el('dish-next').disabled=dishIndex===dishSlides.length-1;
}
el('dish-prev').addEventListener('click',()=>showDish(dishIndex-1));
el('dish-next').addEventListener('click',()=>showDish(dishIndex+1));
el('dish-choice').addEventListener('change',e=>showDish(Number(e.target.value)));
dishTrack.addEventListener('scroll',syncDish,{passive:true});
dishTrack.addEventListener('keydown',e=>{const actions={ArrowLeft:dishIndex-1,ArrowRight:dishIndex+1,Home:0,End:dishSlides.length-1};if(e.key in actions){e.preventDefault();showDish(actions[e.key]);}});
new ResizeObserver(()=>showDish(dishIndex)).observe(dishTrack);
syncDish();
